module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar",
    class: {
      visible: _vm.active
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.brand === 'pl') ? _c('img', {
    attrs: {
      "src": require("../assets/pocketlegal.png"),
      "alt": "PocketLegal"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.brand === 'ie') ? _c('img', {
    attrs: {
      "src": require("../assets/immiexperts.png"),
      "alt": "Immigration Experts"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('ul', {
    staticClass: "menu"
  }, [_c('li', {
    staticClass: "menu-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/#"
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', {
    staticClass: "menu-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/userlist/admin/"
    }
  }, [_vm._v("Team")])], 1), _vm._v(" "), _c('li', {
    staticClass: "menu-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/userlist/client/"
    }
  }, [_vm._v("Clients")])], 1), _vm._v(" "), _c('li', {
    staticClass: "menu-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/visatypes/"
    }
  }, [_vm._v("Matter Types")])], 1), _vm._v(" "), _c('li', {
    staticClass: "menu-item",
    class: {
      activated: _vm.inEditor
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/docs/choosecategory/true/none"
    }
  }, [_vm._v("Document Editor")])], 1), _vm._v(" "), _c('li', {
    staticClass: "menu-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/matters/"
    }
  }, [_vm._v("Matters")])], 1), _vm._v(" "), _c('li', {
    staticClass: "menu-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/accounts/"
    }
  }, [_vm._v("Accounts")])], 1), _vm._v(" "), _c('li', {
    staticClass: "menu-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/agreements/"
    }
  }, [_vm._v("Cost Agreements")])], 1), _vm._v(" "), _c('li', {
    staticClass: "menu-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/pay/"
    }
  }, [_vm._v("Payment")])], 1), _vm._v(" "), _c('li', {
    staticClass: "menu-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/vevo/"
    }
  }, [_vm._v("VEVO")])], 1), _vm._v(" "), _c('li', {
    staticClass: "menu-item mobileOnly",
    on: {
      "click": _vm.logout
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Logout")])])]) : _c('ul', {
    staticClass: "menu"
  }, [_c('li', {
    staticClass: "menu-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/clienthome"
    }
  }, [_vm._v("\n          Home\n        ")])], 1), _vm._v(" "), _vm._l((_vm.matters), function(m, i) {
    return _c('li', {
      staticClass: "menu-item"
    }, [_c('router-link', {
      attrs: {
        "to": '/client-matter/' + i
      }
    }, [_vm._v("\n          Questions")])], 1)
  }), _vm._v(" "), _c('li', {
    staticClass: "menu-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/documents"
    }
  }, [_vm._v("\n          Documents\n        ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "menu-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/invoices"
    }
  }, [_vm._v("\n          Invoices\n        ")])], 1), _vm._v(" "), (_vm.agreement) ? _c('li', {
    staticClass: "menu-item"
  }, [_c('button', {
    staticClass: "btn btn-link",
    on: {
      "click": _vm.viewAgreement
    }
  }, [_vm._v("Costs Agreement")])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "menu-item mobileOnly",
    on: {
      "click": _vm.logout
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n        Logout")])])], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-435a5c75"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar.vue
// module id = 493
// module chunks = 1